export const direction: any = {
  ar: "rtl",
  en: "ltr",
};
